
export const Data = [
  {
    type:"zh",
    content: {
      beijing:{
        text1:{
          type:"text",
          content:"中国北京"
        },
        text2:{
          type:"text",
          content:"牙客邦北京总部"
        },
        text3:{
          type:"text",
          content:"地址："
        },
        text4:{
          type:"text",
          content:"北京市顺义区马坡镇聚源中路12号院11号楼201、202"
        },
        text5:{
          type:"text",
          content:"电话："
        },
        text6:{
          type:"text",
          content:"010-56467587"
        },
        text7:{
          type:"text",
          content:"邮箱："
        },
        text8:{
          type:"text",
          content:"info@yacobon.com"
        },
        url:{
          type:"img",
          content:"http://116.62.38.250//image/nr/lxwm/bj.png"
        }
      },
      suzhou:{
        text1:{
          type:"text",
          content:"中国苏州"
        },
        text2:{
          type:"text",
          content:"牙客邦苏州总部"
        },
        text3:{
          type:"text",
          content:"地址："
        },
        text4:{
          type:"text",
          content:"江苏省苏州市吴中区郭巷尹山湖路 999 号吴中生物医药产业园一期 A 幢一层"
        },
        text5:{
          type:"text",
          content:"电话："
        },
        text6:{
          type:"text",
          content:"400-178-1617"
        },
        text7:{
          type:"text",
          content:"邮箱："
        },
        text8:{
          type:"text",
          content:"info@yacobon.com"
        },
        url:{
          type:"img",
          content:"http://116.62.38.250//image/nr/lxwm/sz.png"
        }
      },

      homeLeave:{
        text1:{
          type:"",
          content:"留言反馈"
        },
        text2:{
          type:"",
          content:"为您提供咨询服务，与您一起提升口腔激光医学水平"
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"姓名",
        text2:"您的手机号",
        text3:"您的微信",
        text4:"留下您的建议和意见",
        commit:"提交"
      }



    }

  },
  {
    type:"en",
    content: {
      beijing:{
        text1:{
          type:"text",
          content:"中国北京"
        },
        text2:{
          type:"text",
          content:"牙客邦北京总部"
        },
        text3:{
          type:"text",
          content:"地址："
        },
        text4:{
          type:"text",
          content:"北京市顺义区马坡镇聚源中路12号院11号楼201、202"
        },
        text5:{
          type:"text",
          content:"电话："
        },
        text6:{
          type:"text",
          content:"010-56467587"
        },
        text7:{
          type:"text",
          content:"邮箱："
        },
        text8:{
          type:"text",
          content:"info@yacobon.com"
        },
        url:{
          type:"img",
          content:"http://116.62.38.250//image/nr/lxwm/bj.png"
        }
      },
      suzhou:{
        text1:{
          type:"text",
          content:"Suzhou, China"
        },
        text2:{
          type:"text",
          content:"Yacob Suzhou Headquarters"
        },
        text3:{
          type:"text",
          content:"Address："
        },
        text4:{
          type:"text",
          content:"1st Floor, Building A, Phase I of Wuzhong Biomedical Industrial Park, No. 999 Yinshanhu Road, Guoxiang, Wuzhong District, Suzhou City, Jiangsu Province"
        },
        text5:{
          type:"text",
          content:"Tel："
        },
        text6:{
          type:"text",
          content:"400-178-1617"
        },
        text7:{
          type:"text",
          content:"Email："
        },
        text8:{
          type:"text",
          content:"info@yacobon.com"
        },
        url:{
          type:"img",
          content:"http://116.62.38.250//image/nr/lxwm/sz.png"
        }
      },
      homeLeave:{
        text1:{
          type:"",
          content:"Message and Feedback"
        },
        text2:{
          type:"",
          content:"We provide you with consultation services and work together with you to enhance the level of oral laser medicine."
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"Name",
        text2:"Mobile Phone Number",
        text3:"WeChat ID",
        text4:"Please leave your suggestions and opinions.",
        commit:"Submit"
      }

    }

  },
];



// WEBPACK FOOTER //
// ./src/components/js/contactUs.js